// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"0c1a88f4","239":"c1ab1a48","398":"fc8fc25c","453":"d3ed2924","455":"b39aed77","468":"bbd4f5eb","544":"2a00acee","546":"25a68cd3","854":"71909b2c","965":"43523030","977":"1a8afd9f"}[chunkId] + ".chunk.js";
};